document.addEventListener("click", function (e) {
//alert("hi");
  const tab = e.target.closest(".tab-buttons a");
  if (!tab) return;

  e.preventDefault();

  const tabContainer = tab.closest(".tab-buttons");
  const mainWrapper = tabContainer.closest(".section-content-wrapper");

  const tabs = tabContainer.querySelectorAll("a");
  const contents = mainWrapper.querySelectorAll(".tab-content");

  const index = Array.prototype.indexOf.call(tabs, tab);

  tabs.forEach(t => t.classList.remove("active"));
  contents.forEach(c => c.classList.remove("active"));

  tab.classList.add("active");

  if (contents[index]) {
    contents[index].classList.add("active");
  }

});
